import {StoryScene, Story, StoryId, StorySceneId} from '../../models/Story'
import {Notification} from '../../models/Notification'
import { applyFilters, getNotificationsByUser, applyNotificationsToScenes } from './filters/filterNotifications'

export const getNotificationsAsStories = (notifications: Notification[] = []): Story[] => {
    const filteredNotifications = applyFilters(notifications)
    const notificationsByUser = getNotificationsByUser(filteredNotifications)
    const stories: Story[] = []

    for (const key in notificationsByUser) {
        const notifs = notificationsByUser[key];
        const sortedNotifs = notifs.sort((a, b) => new Date(a.created).getTime() - new Date(b.created).getTime());
        const {userThatMadeTheAction} = notifs[0]
        const latestTimeStamp = new Date(sortedNotifs.slice(-1)[0].created).getTime()

        const filteredNotifs = notifs.filter((item) => (new Date(item.created).getTime() > Date.now() - 24 * 60 * 60 * 1000));
        if(filteredNotifs.length) {
            const scenes = applyNotificationsToScenes(filteredNotifs)

            const story: Story = {
                user: userThatMadeTheAction,
                timestamp: latestTimeStamp,
                scenes
            }
            stories.push(story)
        }

    }

    return stories.sort((a, b) => b.timestamp - a.timestamp)
}

export const getNonSeenScene = (scenes: StoryScene[] = []) => {
    const seenScenes = scenes.filter(scene => !!scene.seen)
    if(!seenScenes.length || scenes.length < 2) return scenes[0]

    const lastSeen = seenScenes.slice(-1)[0]
    if(lastSeen.id === scenes.slice(-1)[0].id) return scenes[0]
    
    const sceneInd = scenes.findIndex(s => s.id === lastSeen.id)
    if(sceneInd === -1) return scenes[0]
    return scenes[sceneInd + 1]
} 

export const STORY_CONTROL_TYPES = {
    NEXT_STORY: 'NEXT_STORY',
    PREV_STORY: 'PREV_STORY',
    NEXT_SCENE: 'NEXT_SCENE',
    PREV_SCENE: 'PREV_SCENE',
    NEXT_HIDE: 'NEXT_HIDE',
    PREV_HIDE: 'PREV_HIDE',
}

export interface GetStoryControlAction {
    sceneId: StorySceneId
    currentStoryId: StoryId
    stories: Story[]
}

export const getStoryControlNextAction = ({sceneId, currentStoryId, stories}: GetStoryControlAction) => {
    const storyInd = stories.findIndex(s => s.user.auth0_id === currentStoryId)
    if(storyInd === -1) {
        return STORY_CONTROL_TYPES.NEXT_HIDE
    }

    const currentStory = stories[storyInd]
    if(!currentStory){
        return STORY_CONTROL_TYPES.NEXT_HIDE
    }
    const {scenes = []} = currentStory
    const sceneInd = scenes.findIndex(sc => sc.id === sceneId)
    if(sceneInd === -1) {
        return STORY_CONTROL_TYPES.NEXT_HIDE
    }
    if(sceneInd === scenes.length - 1) {
        return storyInd === stories.length -1 ? 
            STORY_CONTROL_TYPES.NEXT_HIDE :
            STORY_CONTROL_TYPES.NEXT_STORY
    }
    return STORY_CONTROL_TYPES.NEXT_SCENE
}

export const getStoryControlPrevAction = ({sceneId, currentStoryId, stories}: GetStoryControlAction) => {
    const storyInd = stories.findIndex(s => s.user.auth0_id === currentStoryId)
    if(storyInd === -1) {
        return STORY_CONTROL_TYPES.PREV_HIDE
    }

    const currentStory = stories[storyInd]
    if(!currentStory){
        return STORY_CONTROL_TYPES.PREV_HIDE
    }
    const {scenes = []} = currentStory
    const sceneInd = scenes.findIndex(sc => sc.id === sceneId)
    if(sceneInd === -1) {
        return STORY_CONTROL_TYPES.PREV_HIDE
    }
    if(sceneInd === 0) {
        return storyInd === 0 ? 
            STORY_CONTROL_TYPES.PREV_HIDE :
            STORY_CONTROL_TYPES.PREV_STORY
    }
    return STORY_CONTROL_TYPES.PREV_SCENE
}